import { useSelector } from "react-redux";
import SyIcon from "../../../../../shared/components/sy-icon";
import { getCommunityDetails } from "../../../../../feature/community-slice/community-slice";
import styleSheet from "../style.module.scss";
import { useTranslation } from "react-i18next";
import planetService from "../../../services/planet-service";
import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { getOrbitDetails } from "../../../../../feature/orbit-slice";
import SyPopup from "../../../../../shared/components/sy-model";
import OrbConfirmation from "../../../../../shared/components/orb-confirmation";
import { useState } from "react";
import { btnConfig } from "../community-config";
import OrbTimeLine from "../../../../../shared/components/orb-timeline";
import { getPlanetDetails } from "../../../../../feature/planet-slice";

const CommunityUpdateManage = (props: any) => {
  const { timeLine, doc, timeLineData, updatePlanet } = props;


    const {planetData,planetStatus,planetAccess} = useSelector(getPlanetDetails);
    
  const communitySlice = useSelector(getCommunityDetails);
  const orbitSlice = useSelector(getOrbitDetails);
  const { t } = useTranslation();
  const { orbitId, planetId } = useParams();

  const onClickSend = (value: any, type: any = null) => {
    if (type === "flag") {
      const payload = {
        otl_id: value.otl_id,
        state: value.flag ? 0 : 1,
      };
      addFlag(payload);
    } else if (type === "edit") {
      const payload = {
        otl_timeline: value.otl_timeline,
      };
      const val = {
        payload: payload,
        id: value.otl_id,
      };
      editTimeLine(val);
    } else if (type === "delete") {
      deleteTimeLine(value.otl_id);
    } else {
      const payload = {
        timeline: value,
        pro_id: planetId,
        orb_id: orbitId,
      };
      addTimeLine(payload);
    }
  };


  const { mutate: addTimeLine } = useMutation({
    mutationFn: planetService.addTimeLine,
    onSuccess(data, variables, context) {
      updatePlanet("timeLine");
    },
  });

  const { mutate: editTimeLine } = useMutation({
    mutationFn: planetService.editTimeLine,
    onSuccess(data, variables, context) {
      updatePlanet("timeLine");
    },
  });
  const { mutate: deleteTimeLine } = useMutation({
    mutationFn: planetService.deleteTimeLine,
    onSuccess(data, variables, context) {
      updatePlanet("timeLine");
    },
  });

  const { mutate: addFlag } = useMutation({
    mutationFn: planetService.addFlag,
    onSuccess(data, variables, context) {
      updatePlanet("timeLine");
    },
  });

  return (
    <>

      <div className="d-flex justify-content-between flex-wrap pt-5 pb-4 w-100">
        <div className="d-flex pointer" onClick={timeLine}>
          <SyIcon
            name={"trending_flat"}
            iconColor="rgba(255, 255, 255, 0.3)"
            className={`${
              communitySlice.timeLine ? styleSheet.up : styleSheet.down
            } me-1  `}
            size="md"
          />
          <h5 className="text-white  mohave m-0 mt-2">{t("time_line")}</h5>
        </div>
        {(planetData.isAdmin || planetAccess ===1 || planetAccess ===2  || planetAccess ===3 )&& (
          <div className="d-flex  pe-3 pointer" onClick={doc}>
            <SyIcon
              name={"trending_flat"}
              iconColor="rgba(255, 255, 255, 0.3)"
              className={`${
                communitySlice.doc ? styleSheet.rotate : ""
              } me-1  `}
              size="md"
            />
            <h5 className="text-white  mohave m-0 mt-2">{t("doc")}</h5>
          </div>
        )}
      </div>
      {communitySlice.timeLine ? (
        <div className="overflow-auto">
          <OrbTimeLine
            editTimeLine={planetData.isAdmin || planetAccess ===1 || planetAccess ===2 }
            timeLineData={timeLineData}
            onClickSend={onClickSend}
            color={" #7B9B53"}
          />
        </div>
      ) : null}
    </>
  );
};
export default CommunityUpdateManage;
